import { useEffect } from 'react';
import { Client, Message, MQTTError } from 'paho-mqtt';
import { useApplicationStore } from '@data';
import { emitMqttEvent } from './mqttEventBus';
import { parseMqttMessage } from './utils';
import { getValue } from '@quickmd-llc/frontend-utils';
import { MqttEventPayload, MqttEventType } from './constants';

const host = import.meta.env.VITE_MQTT_URI;
const port = Number(import.meta.env.VITE_MQTT_PORT);
const userName = import.meta.env.VITE_MQTT_USERNAME;
const password = import.meta.env.VITE_MQTT_PASSWORD;
const protocol = '/ws/mqtt';
const mqttRandomClientId = crypto.randomUUID();

let mqttClient: Client | null = null;

type Params = {
  topic: string;
};

export function initMqttClient({ topic }: Params) {
  if (mqttClient) {
    return;
  }

  mqttClient = new Client(host, port, protocol, mqttRandomClientId);

  mqttClient.connect({
    keepAliveInterval: 30,
    onSuccess: () => {
      mqttClient?.subscribe(topic, {
        qos: 0,
      });
    },
    onFailure: (e) => {
      console.error('[MQTT] Connection failed', e);
    },
    userName,
    password,
    useSSL: true,
  });

  mqttClient.onConnectionLost = (error: MQTTError) => {
    console.log('[MQTT] Connection lost', error);
  };

  mqttClient.onMessageArrived = (message: Message) => {
    const payload = parseMqttMessage(message);
    // !! CASTING JUST TO FIX NEW ERRORS AFTER UPDATING TYPESCRIPT TO TREAT PARSE VALUES AS UNKNOWN. SHOULD ADD SCHEMA VALIDATION.
    const eventType = getValue(payload, 'eventType') as MqttEventType;

    emitMqttEvent(
      eventType,
      // !! CASTING JUST TO FIX NEW ERRORS AFTER UPDATING TYPESCRIPT TO TREAT PARSE VALUES AS UNKNOWN. SHOULD ADD SCHEMA VALIDATION.
      payload as unknown as MqttEventPayload[MqttEventType],
    );
  };
}

export function useInitMqtt() {
  const patientId = useApplicationStore(
    ({ patient }) => patient?.patientProfile?.patientId,
  );

  useEffect(() => {
    if (!patientId) {
      return;
    }

    const topic = `patients/${patientId}`;

    initMqttClient({ topic });

    return () => {
      mqttClient?.disconnect();
      mqttClient = null;
    };
  }, [patientId]);
}
